/*global angular*/

require('@kathondvla/sri-client/ng-sri-client');
const dateUtils = require('@kathondvla/sri-client/date-utils');

const _ = {
  sortBy: require('lodash/sortBy'),
  findIndex: require('lodash/findIndex')
};

var module = angular.module('curriculumManager', ['ng-sri-client']);

module.factory('curriculumManager', ['sriClient', '$q', 'settings', '$location', '$notification',
  function (sriClient, $q, settings, $location, $notification) {
    'use strict';
    var that = {};
    var curr = $q.defer();
    var curriculumPromise = curr.promise;
    var cm = $q.defer();
    var contentMapPromise = cm.promise;
    var idMap = $q.defer();
    var idMapPromise = idMap.promise;
    var currHash;

    var contentMap = {
      fields: {},
      themes: {},
      goals: {},
      content1s: {},
      content2s: {},
      developmentSteps: {}
    };
    var identifiersMap = {
      fields: {},
      themes: {},
      goals: {}
    };
    var typeMap = {
      CURRICULUM_ZILL_CLUSTER: [],
      CURRICULUM_ZILL_DEVELOPMENT_FIELD: [],
      CURRICULUM_ZILL_DEVELOPMENT_THEME: [],
      CURRICULUM_ZILL_GENERIC_GOAL: [],
      CURRICULUM_ZILL_CONTENT_GROUP: [],
      CURRICULUM_ZILL_DEVELOPMENT_CONTENT: [],
      CURRICULUM_ZILL_LEERLIJN: [],
      leerlijnDevelopmentSteps: []
    };


    var currentCurr = $q.defer();

    var getCurriculumByHref = function (href, root, url) {
      var d = $q.defer();
      var hashTimestamp = '';
      if($location.search().preview){
        console.log('preview');
        hashTimestamp = '?t=' + Math.round(+new Date()/1000)
      }
      sriClient.get(href + '/hash' + hashTimestamp, {}, {baseUrl: url}).then(function (result) {
        currHash = result.hash;
        sriClient.getAll(
          '/content',
          {
            typeIn: 'CURRICULUM_ZILL,CURRICULUM_ZILL_CLUSTER,CURRICULUM_ZILL_DEVELOPMENT_FIELD,CURRICULUM_ZILL_DEVELOPMENT_THEME,CURRICULUM_ZILL_GENERIC_GOAL,CURRICULUM_ZILL_DEVELOPMENT_CONTENT,CURRICULUM_ZILL_LEERLIJN,CURRICULUM_ZILL_LEERLIJN_PRE_REFERENCE,CURRICULUM_ZILL_LEERLIJN_CLUSTER,CURRICULUM_ZILL_LEERLIJN_POST_REFERENCE,CURRICULUM_ZILL_CONTENT_GROUP',
            root: href,
            limit: 6000
          },
          {
            baseUrl: url,
            headers: {
              'VSKO-Resource-Hash': currHash
            }
          }
        ).then(function (results) {
          results.unshift(root);
          d.resolve(results);
        }, function (errors) {
          $notification.error('<small>currilcum.by.href.full</small><br>Het curriculum kon niet worden geladen.'); // to remove when errors are put in jsonobject
          console.error(errors); // to remove when errors are put in jsonobject
          d.reject(errors);
        });
      }, function (errors) {
        $notification.error('<small>currilcum.by.href.hash</small><br>Het curriculum kon niet worden geladen.'); // to remove when errors are put in jsonobject
        console.error(errors); // to remove when errors are put in jsonobject
        d.reject(errors);
      });
      return d.promise;
    };

    /**
     * get curricullum from content. The result is the array with all the elements unsorted.
     */
    var getCurriculumFromContent = function (href, date, url) {
      var d = $q.defer();
      var i;
      if (href) {
        sriClient.get(href, {}, {baseUrl: url}).then(function (root) {
          getCurriculumByHref(href, root, url).then(function (curr) {
            d.resolve(curr);
          });
        }, function (errors) {
          $notification.error('<small>currilcum.from.content.version</small><br>Het curriculum kon niet worden geladen.'); // to remove when errors are put in jsonobject
          console.error(errors); // to remove when errors are put in jsonobject
        });

      }
      else {
        if (!date) {
          date = dateUtils.toString(new Date());
        }
        sriClient.getList(
          '/content',
          {
            typeIn: 'CURRICULUM_ZILL,CURRICULUM_ZILL_CLUSTER,CURRICULUM_ZILL_DEVELOPMENT_FIELD,CURRICULUM_ZILL_DEVELOPMENT_THEME,CURRICULUM_ZILL_GENERIC_GOAL,CURRICULUM_ZILL_DEVELOPMENT_CONTENT,CURRICULUM_ZILL_LEERLIJN,CURRICULUM_ZILL_LEERLIJN_PRE_REFERENCE,CURRICULUM_ZILL_LEERLIJN_CLUSTER,CURRICULUM_ZILL_LEERLIJN_POST_REFERENCE,CURRICULUM_ZILL_CONTENT_GROUP',
            type: 'CURRICULUM_ZILL',
            issuedBefore: date + 'T23:59',
            limit: 1,
            orderBy: 'issued',
            descending: true
          },
          {
            baseUrl: url
          }
        ).then(function (results) {
          if (results.length === 0) {
            $notification.error('Er is geen leerplan gepubliceerd op ' + date + '.');
            return;
          }
          var lastPublished;
          for (var i = 0; i < results.length; i++) {
            var lp = results[i];
            if (!lastPublished || lastPublished.issued < lp.issued) {
              lastPublished = lp;
            }
          }
          currentCurr.resolve(lastPublished);
          getCurriculumByHref(lastPublished.$$meta.permalink, lastPublished, url).then(function (curr) {
            d.resolve(curr);
          });
        }, function (errors) {
          $notification.error('<small>currilcum.from.content.latest</small><br>Het curriculum kon niet worden geladen.'); // to remove when errors are put in jsonobject
          console.error(errors); // to remove when errors are put in jsonobject
        });
      }
      return d.promise;
    };

    var getIconUrl = function (field, url) {
      var href, i;
      for (i = 0; i < field.attachments.length; i++) {
        if (field.attachments[i].type === 'ICON') {
          href = field.attachments[i].href + '?' + currHash;
          break;
        }
      }
      return url + href;
    };

    var getCoverUrl = function (field, fallback, url) {
      var cover, i;
      for (i = 0; i < field.attachments.length; i++) {
        if (field.attachments[i].type === 'COVER_IMAGE') {
          cover = url + field.attachments[i].href + '?' + currHash;
          break;
        }
      }
      if (!cover && fallback) {
        cover = fallback.coverUrl;
      }
      return cover;
    };

    var getThumbUrl = function (field, fallback, url) {
      var thumb, i;
      for (i = 0; i < field.attachments.length; i++) {
        if (field.attachments[i].type === 'THUMBNAIL') {
          thumb = url + field.attachments[i].href + '?' + currHash;
          break;
        }
      }
      if (!thumb && fallback) {
        thumb = fallback.thumbUrl;
      }
      return thumb;
    };

    var getBackgroundUrl = function (field, url) {
      var background, i;
      for (i = 0; i < field.attachments.length; i++) {
        if (field.attachments[i].type === 'BACKGROUND_IMAGE') {
          background = url + field.attachments[i].href + '?' + currHash;
          break;
        }
      }
      return background;
    };

    var findChildInList = function (relation, list, fromTo) {
      var href = relation[fromTo].href.split('/')[relation[fromTo].href.split('/').length - 1];
      var child = list[href];
      if (fromTo == 'from' && child && relation.readorder) {
        child.readorder = relation.readorder;
      }
      return child;
    };

    var handleTreeElement = function (elem, parentName, parent, simpleParent, plural, inContentMap) {
      if (elem) {
        elem.parentName = parentName;
        elem[parentName] = simpleParent;
        if (elem.code) {
          identifiersMap[plural][elem.code] = elem;
        }
        if (inContentMap) {
          contentMap[plural][elem.$$meta.permalink] = elem;
        }
        parent[plural].push(elem);
      } else {
        console.error(parent);
      }
    };

    /**
     * Method to be called on startup of the application that will prepare the
     * curriculum in an ordered tree and cache it here;
     * Convert array of results to an ordered tree;
     */
    that.prepareCurriculum = function (href, date, url) {
      if (!curriculumPromise.done) {
        if (typeof url === 'undefined') { //another url is given in the state and should overwrite the url in the settings
          url = settings.apisAndUrls.api;
        }
        getCurriculumFromContent(href, date, url).then(function (results) {
          console.time('Building Tree');
          var curriculum, i;
          for (i = 0; i < results.length; i++) {
            var part = results[i];
            //group parts
            if (part.type === 'CURRICULUM_ZILL') {
              curriculum = part;
            } else {
              if (typeMap.hasOwnProperty(part.type)) {
                typeMap[part.type][part.key] = part;
              } else {
                if (part.type === 'CURRICULUM_ZILL_LEERLIJN_CLUSTER' || part.type === 'CURRICULUM_ZILL_LEERLIJN_PRE_REFERENCE' || part.type === 'CURRICULUM_ZILL_LEERLIJN_POST_REFERENCE') {
                  typeMap.leerlijnDevelopmentSteps[part.key] = part;
                } else {
                  console.warn('UNKNOWN curriculum type: ' + part.type);
                }
              }
            }
          }
          curriculum.clusters = [];
          curriculum.coverUrl = getCoverUrl(curriculum, null, url);
          curriculum.thumbUrl = getThumbUrl(curriculum, null, url);
          curriculum.background = getBackgroundUrl(curriculum, url);
          for (i = 0; i < curriculum.$$relationsTo.length; i++) {
            var cluster = findChildInList(curriculum.$$relationsTo[i].$$expanded, typeMap.CURRICULUM_ZILL_CLUSTER, 'from');
            if (cluster) {
              var simpleCluster = cluster;
              curriculum.clusters.push(cluster);
              cluster.fields = [];
              for (var j = 0; j < cluster.$$relationsTo.length; j++) {
                var field = findChildInList(cluster.$$relationsTo[j].$$expanded, typeMap.CURRICULUM_ZILL_DEVELOPMENT_FIELD, 'from');
                if (field) {
                  field.code = field.identifiers[0];
                  handleTreeElement(field, 'cluster', cluster, simpleCluster, 'fields', true);
                  field.iconUrl = getIconUrl(field, url);
                  field.coverUrl = getCoverUrl(field, curriculum, url);
                  field.thumbUrl = getThumbUrl(field, curriculum, url);
                  field.background = getBackgroundUrl(field, url);
                  var simpleField = field;
                  field.themes = [];
                  var preZero = '00';
                  field.sort = parseInt((preZero + cluster.readorder).slice(-preZero.length)
                                          + (preZero + field.readorder).slice(-preZero.length));
                  for (var k = 0; k < field.$$relationsTo.length; k++) {
                    var theme = findChildInList(field.$$relationsTo[k].$$expanded, typeMap.CURRICULUM_ZILL_DEVELOPMENT_THEME, 'from');
                    if (theme) {
                      theme.code = field.code + theme.identifiers[0];
                      theme.coverUrl = getCoverUrl(theme, field, url);
                      theme.thumbUrl = getThumbUrl(theme, field, url);
                      handleTreeElement(theme, 'field', field, simpleField, 'themes', true);
                      var simpleTheme = theme;
                      theme.goals = [];
                      for (var l = 0; l < theme.$$relationsTo.length; l++) {
                        var goal = findChildInList(theme.$$relationsTo[l].$$expanded, typeMap.CURRICULUM_ZILL_GENERIC_GOAL, 'from');
                        if (goal) {
                          goal.code = theme.code + goal.identifiers[0];
                          handleTreeElement(goal, 'theme', theme, simpleTheme, 'goals', true);
                          var simpleGoal = goal;
                          goal.contentGroups = [];
                          var preZero = '000';
                          goal.sort = parseInt((preZero + cluster.readorder).slice(-preZero.length)
                                                 + (preZero + field.readorder).slice(-preZero.length)
                                                 + (preZero + theme.readorder).slice(-preZero.length)
                                                 + (preZero + goal.readorder).slice(-preZero.length));
                          for (var m = 0; m < goal.$$relationsTo.length; m++) {
                            var contentGroup = findChildInList(goal.$$relationsTo[m].$$expanded, typeMap.CURRICULUM_ZILL_CONTENT_GROUP, 'from');
                            if (contentGroup) {
                              handleTreeElement(contentGroup, 'goal', goal, simpleGoal, 'contentGroups', false);
                              var simpleContentGroup = contentGroup;
                              contentGroup.content1s = [];
                              for (var n = 0; n < contentGroup.$$relationsTo.length; n++) {
                                if (contentGroup.$$relationsTo[n].$$expanded.relationtype === 'IS_PART_OF') {
                                  var content1 = findChildInList(contentGroup.$$relationsTo[n].$$expanded, typeMap.CURRICULUM_ZILL_DEVELOPMENT_CONTENT, 'from');
                                  if (content1) {
                                    handleTreeElement(content1, 'contentGroup', contentGroup, simpleContentGroup, 'content1s', true);
                                    var simpleContent1 = content1;
                                    content1.content2s = [];
                                    content1.$$goal = goal;
                                    for (var o = 0; o < content1.$$relationsTo.length; o++) {
                                      if (content1.$$relationsTo[o].$$expanded.relationtype === 'IS_PART_OF') {
                                        var content2 = findChildInList(content1.$$relationsTo[o].$$expanded, typeMap.CURRICULUM_ZILL_DEVELOPMENT_CONTENT, 'from');
                                        if (content2) {
                                          handleTreeElement(content2, 'content1', content1, simpleContent1, 'content2s', true);
                                          var simpleContent2 = content2;
                                          content2.$$goal = goal;
                                          for (var p = 0; p < content2.$$relationsTo.length; p++) {
                                            if (content2.$$relationsTo[p].$$expanded.relationtype === 'IS_PART_OF') {
                                              appendLeerlijn(p, content2, simpleContent2, 'content2');
                                            }
                                          }
                                        } else {
                                          appendLeerlijn(o, content1, simpleContent1, 'content1');
                                        }
                                      }
                                    }
                                    cm.resolve(contentMap);
                                    content1.content2s = _.sortBy(content1.content2s, [function (o) {
                                      return parseInt(o.readorder);
                                    }]);
                                  } else {
                                    //console.warn('Childrelation of a content group where from is not a CURRICULUM_ZILL_DEVELOPMENT_CONTENT: ' + JSON.stringify(contentGroup.$$relationsTo[n]));
                                  }
                                }
                              }
                              contentGroup.content1s = _.sortBy(contentGroup.content1s, [function (o) {
                                return parseInt(o.readorder);
                              }]);
                            } else {
                              appendLeerlijn(m, goal, simpleGoal, 'goal');
                            }
                          }
                          goal.contentGroups = _.sortBy(goal.contentGroups, [function (o) {
                            return parseInt(o.readorder);
                          }]);
                        }
                      }
                      theme.goals = _.sortBy(theme.goals, [function (o) {
                        return parseInt(o.readorder);
                      }]);
                    }
                  }
                  field.themes = _.sortBy(field.themes, [function (o) {
                    return parseInt(o.readorder);
                  }]);
                }
              }
              cluster.fields = _.sortBy(cluster.fields, [function (o) {
                return parseInt(o.readorder);
              }]);
            }
          }
          idMap.resolve(identifiersMap);
          curriculum.clusters = _.sortBy(curriculum.clusters, [function (o) { return parseInt(o.readorder); }]);
          for (var i = 0; i < referencedGoals.length; i++) {
            referencedGoals[i].step.referencedGoal = contentMap.goals[referencedGoals[i].key];
          }
          console.timeEnd('Building Tree');
          curr.resolve(curriculum);
        }, function (errors) {
          curr.reject(errors);
        });
      }
      return curriculumPromise;
    };

    var referencedGoals = [];
    var appendLeerlijn = function (i, parent, simpleParent, parentName) {
      var leerlijn = findChildInList(parent.$$relationsTo[i].$$expanded, typeMap.CURRICULUM_ZILL_LEERLIJN, 'from');
      if (leerlijn) {
        leerlijn.parentName = parentName;
        leerlijn[parentName] = simpleParent;
        if (!leerlijn.educationsorts || (leerlijn.educationsorts && leerlijn.educationsorts.indexOf('/onderwijssoorten/0c739f2c-2acf-11e5-937b-00ff001a7a08') > -1)) {
          parent.leerlijn = leerlijn;
        } else if (leerlijn.educationsorts && leerlijn.educationsorts.indexOf('/onderwijssoorten/0c739f38-2acf-11e5-937b-00ff001a7a08') - 1) {
          parent.leerlijnBuBao = leerlijn;
        }
        var simpleLeerlijn = leerlijn;
        leerlijn.developmentSteps = [];
        for (var j = 0; j < leerlijn.$$relationsTo.length; j++) {
          if (leerlijn.$$relationsTo[j].$$expanded.relationtype === 'IS_PART_OF') {
            var developmentStep = findChildInList(leerlijn.$$relationsTo[j].$$expanded, typeMap.leerlijnDevelopmentSteps, 'from');
            if (developmentStep) {
              if(parent.$$goal) {
                developmentStep.$$goal = parent.$$goal;
              } else {
                developmentStep.$$goal = parent;
              }
              if (developmentStep.$$relationsFrom) {
                for (var k = 0; k < developmentStep.$$relationsFrom.length; k++) {
                  if (developmentStep.$$relationsFrom[k].$$expanded.relationtype === 'REFERENCES') {
                    referencedGoals.push({
                                           step: developmentStep,
                                           key: developmentStep.$$relationsFrom[k].$$expanded.to.href
                                         });
                  }
                }
              }
              else {
                console.warn('Childrelation of a leerlijn where from is not a development step: ' + JSON.stringify(leerlijn.$$relationsTo[j]));
              }
              handleTreeElement(developmentStep, 'leerlijn', leerlijn, simpleLeerlijn, 'developmentSteps', true);
            } else {
              console.warn('developmentStep Missing: ' + JSON.stringify(leerlijn.$$relationsTo[j]));
            }
          }
        }
        /*leerlijn.developmentSteps = _.sortBy(leerlijn.developmentSteps, [function (o) {
         switch (o.type) {
         case 'CURRICULUM_ZILL_LEERLIJN_PRE_REFERENCE': return 0; break;
         case 'CURRICULUM_ZILL_LEERLIJN_CLUSTER': return 1; break;
         case 'CURRICULUM_ZILL_LEERLIJN_POST_REFERENCE': return 2; break;
         }
         }, 'startage', 'endage']);*/
        leerlijn.developmentSteps = _.sortBy(leerlijn.developmentSteps, [function (o) { return parseInt(o.readorder); }]);
        if (leerlijn.developmentSteps.length === 0) {
          parent.leerlijn = undefined;
        }
      }
      else {
        /*console.warn('Childrelation of a ' + parentName + ' where from is not a CURRICULUM_ZILL_LEERLIJN or a ' +
         (parentName === 'goal' ? 'CURRICULUM_ZILL_CONTENT_GROUP' : 'CURRICULUM_ZILL_DEVELOPMENT_CONTENT') + ': ' +
         JSON.stringify(parent.$$relationsTo[i])); */
      }
    };

    /**
     * Returns the cached curriculum tree as a promise;
     */
    that.getCurriculum = function () {
      return curriculumPromise;
    };

    that.getFields = function () {
      var d = $q.defer();
      that.getCurriculum().then(function (curr) {
        var ret = [];
        for (var i = 0; i < curr.clusters.length; i++) {
          ret = ret.concat(curr.clusters[i].fields);
        }
        d.resolve(ret);
      });
      return d.promise;
    };

    that.getFieldFromContentOrGoal = function (cgHref) {
      var d = $q.defer();
      contentMapPromise.then(function (contentMap) {
        var obj = contentMap.goals[cgHref];
        //is it a goal?
        if (obj) {
          d.resolve(obj.theme.field);
        }
        else {
          obj = contentMap.content1s[cgHref];
          // is it a content1?
          if (obj) {
            d.resolve(obj.contentGroup.goal.theme.field);
          }
          else {
            obj = contentMap.content2s[cgHref];
            //is it a content2?
            if (obj) {
              d.resolve(obj.content1.contentGroup.goal.theme.field);
            }
            else {
              d.resolve(null);
            }
          }
        }
      });
      return d.promise;
    };

    that.getFieldFromHref = function (cgHref) {
      var d = $q.defer();
      contentMapPromise.then(function (contentMap) {
        var obj = contentMap.goals[cgHref];
        //is it a goal?
        if (obj) {
          d.resolve(obj.theme.field);
        }
        else {
          obj = contentMap.content1s[cgHref];
          // is it a content1?
          if (obj) {
            d.resolve(obj.contentGroup.goal.theme.field);
          }
          else {
            obj = contentMap.content2s[cgHref];
            //is it a content2?
            if (obj) {
              d.resolve(obj.content1.contentGroup.goal.theme.field);
            }
            else {
              d.resolve(null);
            }
          }
        }
      });
      return d.promise;
    };

    that.getSelectionDirect = function (href) {
      var obj = contentMap.goals[href];
      // is it not a goal?
      if (!obj) {
        obj = contentMap.content1s[href];
        // is it not a content1?
        if (!obj) {
          obj = contentMap.content2s[href];
          //is it not a content2?
          if (!obj) {
            obj = contentMap.developmentSteps[href];
            //is it not a development step?
            if (!obj) {
              obj = null;
            }
          }
        }
      }
      return obj;
    };

    that.getSelection = function (href) {
      var d = $q.defer();
      contentMapPromise.then(function (contentMap) {
        d.resolve(that.getSelectionDirect(href));
      });
      return d.promise;
    };

    var getFields = function (curriculum, clusterIdentifier) {
      for (var i = 0; curriculum.clusters.length; i++) {
        if (curriculum.clusters[i].identifiers[0] === clusterIdentifier) {
          return curriculum.clusters[i].fields;
        }
      }
    };

    that.isCulturalGoal = function (goal) {
      return goal.theme.field.cluster.identifiers[0] === 'CG';
    };

    that.isPersonalGoal = function (goal) {
      return goal.theme.field.cluster.identifiers[0] === 'PG';
    };

    that.getPersoonsFields = function () {
      var d = $q.defer();
      that.getCurriculum().then(function (curr) {
        d.resolve(getFields(curr, 'PG'));
      });
      return d.promise;
    };

    that.getCultuurFields = function () {
      var d = $q.defer();
      curriculumPromise.then(function (curr) {
        d.resolve(getFields(curr, 'CG'));
      });
      return d.promise;
    };

    that.getFieldById = function (id) {
      var d = $q.defer();
      idMapPromise.then(function (map) {
        d.resolve(map.fields[id]);
      });
      return d.promise;
    };

    that.getFieldByHref = function (href) {
      var d = $q.defer();
      contentMapPromise.then(function (contentMap) {
        d.resolve(contentMap.fields[href]);
      });
      return d.promise;
    };

    that.getThemeByHref = function (href) {
      var d = $q.defer();
      contentMapPromise.then(function (contentMap) {
        d.resolve(contentMap.themes[href]);
      });
      return d.promise;
    };

    that.getThemeByIdentifiers = function (fieldId, themeId) {
      var d = $q.defer();
      idMapPromise.then(function (map) {
        d.resolve(map.themes[fieldId + themeId]);
      });
      return d.promise;
    };

    that.getGoalByHref = function (href) {
      var d = $q.defer();
      contentMapPromise.then(function (contentMap) {
        d.resolve(contentMap.goals[href]);
      });
      return d.promise;
    };

    that.getGoalByIdentifiers = function (fieldId, themeId, goalId) {
      var d = $q.defer();
      idMapPromise.then(function (map) {
        d.resolve(map.goals[fieldId + themeId + goalId]);
      });
      return d.promise;
    };

    that.getGoals = function () {
      var d = $q.defer();
      contentMapPromise.then(function (cp) {
        d.resolve(cp.goals);
      });
      return d.promise;
    };

    that.getCurrentCurriculumRoot = function () {
      return currentCurr.promise;
    };

    that.getCurrHash = function () {
      return currHash;
    };

    that.getByHref = function (href) {
      var d = $q.defer();
      var href = href.split('/')[href.split('/').length - 1];
      contentMapPromise.then(function (contentMap) {
        d.resolve(that.getByHrefNoPromise(href));
      });
      return d.promise;
    };

    that.getByHrefNoPromise = function (href) {
      var href = href.split('/')[href.split('/').length - 1];
      var find = typeMap.CURRICULUM_ZILL_CLUSTER[href];
      if (!find) {
        find = typeMap.CURRICULUM_ZILL_DEVELOPMENT_FIELD[href];
        if (!find) {
          find = typeMap.CURRICULUM_ZILL_DEVELOPMENT_THEME[href];
          if (!find) {
            find = typeMap.CURRICULUM_ZILL_GENERIC_GOAL[href];
            if (!find) {
              find = typeMap.leerlijnDevelopmentSteps[href];
              if (!find) {
                find = typeMap.CURRICULUM_ZILL_DEVELOPMENT_CONTENT[href];
                if (!find) {
                  find = typeMap.CURRICULUM_ZILL_LEERLIJN[href];
                  if (!find) {
                    find = typeMap.CURRICULUM_ZILL_CONTENT_GROUP[href];
                  }
                }
              }
            }
          }
        }
      }
      return find;
    };


    that.getNext = function (item) {
      var d = $q.defer();
      if (item.type === 'CURRICULUM_ZILL_GENERIC_GOAL') {
        that.getThemeByHref('/content/' + item.theme.key).then(function (theme) {
          var items = theme.goals;
          var index = _.findIndex(items, {key: item.key});
          var next = items[index + 1];
          if (!next) {
            next = items[0];
          }
          d.resolve(next);
        });
      }
      else if (item.type === 'CURRICULUM_ZILL_DEVELOPMENT_THEME') {
        that.getFieldByHref('/content/' + item.field.key).then(function (field) {
          var items = field.themes;
          var index = _.findIndex(items, {key: item.key});
          var next = items[index + 1];
          if (!next) {
            next = items[0];
          }
          d.resolve(next);
        });
      }
      else if (item.type === 'CURRICULUM_ZILL_DEVELOPMENT_FIELD') {
        that.getFields().then(function (items) {
          var index = _.findIndex(items, {key: item.key});
          var next = items[index + 1];
          if (!next) {
            next = items[0];
          }
          d.resolve(next);
        });
      }
      return d.promise;
    };

    that.getPrev = function (item) {
      var d = $q.defer();
      if (item.type === 'CURRICULUM_ZILL_GENERIC_GOAL') {
        that.getThemeByHref('/content/' + item.theme.key).then(function (theme) {
          var items = theme.goals;
          var index = _.findIndex(items, {key: item.key});
          var prev = items[index - 1];
          if (!prev) {
            prev = items[items.length - 1];
          }
          d.resolve(prev);
        });
      }
      else if (item.type === 'CURRICULUM_ZILL_DEVELOPMENT_THEME') {
        that.getFieldByHref('/content/' + item.field.key).then(function (field) {
          var items = field.themes;
          var index = _.findIndex(items, {key: item.key});
          var prev = items[index - 1];
          if (!prev) {
            prev = items[items.length - 1];
          }
          d.resolve(prev);
        });
      }
      else if (item.type === 'CURRICULUM_ZILL_DEVELOPMENT_FIELD') {
        that.getFields().then(function (items) {
          var index = _.findIndex(items, {key: item.key});
          var prev = items[index - 1];
          if (!prev) {
            prev = items[items.length - 1];
          }
          d.resolve(prev);
        });
      }
      return d.promise;
    };

    return that;
  }
]);
module.exports = module;
